<template>
  <div class="navigation-sidebar">
    <div class="navigation-panel">
      <div class="navigation-items">
        <template v-for="item in navConfigList">
          <div
            class="nav-item"
            :id="item.title === '搜索' ? 'search-control' : ''"
            :key="item.id"
            @click="toTarget(item)"
          >
            <span class="nav-text">{{ setTitle(item.title) }}</span>
            <div class="nav-hover-effect"></div>
          </div>
        </template>
      </div>
    </div>

    <!-- <div class="back-to-top" @click="backTop">
      <div class="top-icon">
        <img :src="goTop" alt="返回顶部" />
      </div>
      <div class="top-hover-effect"></div>
    </div> -->
  </div>
</template>

<script>
import goTop from "@/assets/img/newProducts/goTop.png";
import event from "@/event/index.js";
import tool from "@/utils/tool.js";
import { mapState } from "vuex";

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      goTop,
      navConfigList: []
    };
  },
  methods: {
    setTitle(title) {
      let charStr = "";
      const _title = title.trim();
      if (_title) {
        for (let i = 0; i < 4; i++) {
          charStr += _title.charAt(i);
        }
        if (_title.charAt(4)) {
          charStr += "...";
        }
      }
      return charStr;
    },
    toTarget(item) {
      if (item.title === "搜索") {
        this.$bus.$emit("inputFocus");
        return;
      }
      event.$emit("scrrolToTarget", { type: item.type, id: item.id });
    },
    backTop() {
      const target = document.getElementById("newProductsPage");
      tool.smoothScrollToTop(800, target);
    },
    setConfigList() {
      const navElements = document.getElementsByClassName("config-nav-name");
      // console.log("navElements", navElements);
      const list = [];
      for (let i = 0; i < navElements.length; i++) {
        const navElement = navElements[i];
        const type = navElement.getAttribute("data-type");
        const title = navElement.innerText;
        const id = navElement.getAttribute("data-id");
        list.push({
          type,
          title,
          id
        });
      }
      this.navConfigList = list;
    }
  },
  mounted() {
    this.setConfigList();
    this.$bus.$on("resetLeftNav", () => {
      this.setConfigList();
    });
    // const navElements = document.getElementsByClassName("config-nav-name");
    // console.log("navElements", navElements);
  }
};
</script>

<style lang="scss" scoped>
.navigation-sidebar {
  position: fixed;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.navigation-panel {
  background: #ffffff;
  // border-radius: 0 16px 16px 0;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  }
}

.navigation-items {
  display: flex;
  flex-direction: column;

  .nav-item {
    position: relative;
    width: 45px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 2px;

    &:not(:last-child)::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 40px;
      height: 1px;
      // background: linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.08) 50%, transparent 100%);
      background: linear-gradient(
        90deg,
        color-mix(in srgb, var(--color-primary-dark10) 0%, transparent) 0%,
        color-mix(in srgb, var(--color-primary-dark30) 5%, transparent) 100%
      );
    }

    &:hover {
      background: var(--color-primary);

      .nav-text {
        color: #fff;
        // transform: translateY(-1px);
      }

      .nav-hover-effect {
        opacity: 1;
      }
    }

    .nav-text {
      font-size: 12px;
      font-weight: 500;
      color: #555;
      transition: all 0.3s ease;
      text-align: center;
      // line-height: 1.2;
      padding: 0 4px;
    }

    .nav-hover-effect {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        135deg,
        color-mix(in srgb, var(--color-primary-dark10) 0%, transparent) 0%,
        color-mix(in srgb, var(--color-primary-dark30) 5%, transparent) 100%
      );
      opacity: 0;
      transition: opacity 0.3s ease;
    }
  }
}

.back-to-top {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 66px;
  height: 66px;
  background: #ffffff;
  border-radius: 0 16px 16px 0;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
    background: linear-gradient(
      135deg,
      color-mix(in srgb, var(--color-primary-dark10) 0%, transparent) 0%,
      color-mix(in srgb, var(--color-primary-dark30) 5%, transparent) 100%
    );

    .top-icon img {
      transform: translateY(-2px);
    }

    .top-hover-effect {
      opacity: 1;
    }
  }

  .top-icon {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 48px;
      height: 48px;
      transition: all 0.3s ease;
    }
  }

  .top-hover-effect {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      135deg,
      color-mix(in srgb, var(--color-primary-dark10) 0%, transparent) 0%,
      color-mix(in srgb, var(--color-primary-dark30) 5%, transparent) 100%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .navigation-sidebar {
    top: auto;
    bottom: 20px;
    flex-direction: row;
    left: 50%;
    transform: translateX(-50%);
    gap: 8px;
  }

  .navigation-panel {
    border-radius: 16px;
    order: 1;
  }

  .navigation-items {
    flex-direction: row;

    .nav-item {
      width: auto;
      height: auto;
      padding: 12px 16px;

      &:not(:last-child)::after {
        top: 50%;
        left: auto;
        right: 0;
        transform: translateY(-50%);
        width: 1px;
        height: 30px;
        background: linear-gradient(
          135deg,
          color-mix(in srgb, var(--color-primary-dark10) 0%, transparent) 0%,
          color-mix(in srgb, var(--color-primary-dark30) 5%, transparent) 100%
        );
      }

      .nav-text {
        font-size: 13px;
      }
    }
  }

  .back-to-top {
    border-radius: 16px;
    order: 2;
    width: 60px;
    height: 60px;

    .top-icon img {
      width: 28px;
      height: 28px;
    }
  }
}

@media (max-width: 480px) {
  .navigation-sidebar {
    bottom: 10px;
  }

  .navigation-items .nav-item {
    padding: 10px 12px;

    .nav-text {
      font-size: 12px;
    }
  }

  .back-to-top {
    width: 50px;
    height: 50px;

    .top-icon img {
      width: 24px;
      height: 24px;
    }
  }
}

/* 动画效果 */
@keyframes slideIn {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}

.navigation-sidebar {
  animation: slideIn 0.5s ease-out;
}

.nav-item:hover,
.back-to-top:hover {
  animation: none;
}
</style>
